import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue'
import { ValidationProvider } from 'vee-validate'


export default /*#__PURE__*/_defineComponent({
  __name: 'TextFieldComponent',
  props: {
  validationRules: {
    type: String as PropType<string>,
    required: true
  },
  id: {
    type: String as PropType<string>,
    required: true
  },
  value: {
    type: [String, Number] as PropType<string | number>,
    default: ''
  },
  type: {
    type: String as PropType<string>,
    default: 'text'
  },
  placeholder: {
    type: String as PropType<string>
  },
  prependIcon: {
    type: String as PropType<string>
  },
  appendIcon: {
    type: String as PropType<string>
  },
  autocompleteType: {
    type: String as PropType<string>,
    default: ''
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;



// DATA
const inputType = ref(props.type)

// EVENTS


// METHODS
function emitValue(event: Event) {
  const target = event.target as HTMLInputElement
  emit('input', target.value)
}

function toggleVisible() {
  inputType.value = inputType.value === 'password' ? 'text' : 'password'
}

return { __sfc: true,props, inputType, emit, emitValue, toggleVisible, ValidationProvider }
}

})